import { render, staticRenderFns } from "./DialogWatermark.vue?vue&type=template&id=8fb143a0&scoped=true"
import script from "./DialogWatermark.vue?vue&type=script&lang=js"
export * from "./DialogWatermark.vue?vue&type=script&lang=js"
import style0 from "./DialogWatermark.vue?vue&type=style&index=0&id=8fb143a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb143a0",
  null
  
)

export default component.exports